'use client'
import { useEffect, useRef } from 'react'
import { useAuth } from '@clerk/nextjs'
import { whenIdle, withPostHog } from '@/lib/posthog-client'

/** Records sessions for signed-out visitors. Signed-in recording lives in the authenticated layout. */
export function PostHogAnonRecorder({ signedOut }: { signedOut: boolean }) {
  const started = useRef(false)

  useEffect(() => {
    if (!signedOut || started.current) return

    // Recording loads rrweb (posthog-recorder.js); wait for idle so it doesn't compete with
    // first paint and hydration. Mark started only once it runs, so a cancelled wait retries.
    return whenIdle(() => {
      started.current = true
      withPostHog((posthog) => posthog.startSessionRecording())
    }, 4000)
  }, [signedOut])

  return null
}

/** PostHogAnonRecorder for routes that have Clerk on the client. */
export function ClerkAnonRecorder() {
  const { isLoaded, isSignedIn } = useAuth()
  return <PostHogAnonRecorder signedOut={isLoaded && !isSignedIn} />
}
